import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCurrentCompany } from 'javascripts/hooks';
import steven from 'helpers/steven';
import {
  request,
  type V3ApiFailedResponse,
  type V3ApiSuccessfulResponse,
} from 'javascripts/services/v3ApiClient';
import { PAGE_TEMPLATES_QUERY_KEY } from './useGetPageTemplates';
import { PageObject, PageTemplateObject } from 'data/v3/data-contracts';

type SaveAsPageTemplateResponse = V3ApiSuccessfulResponse<PageTemplateObject>;

type SaveAsPageTemplateParams = {
  title: string;
  description: string;
};

export const useSaveAsPageTemplate = ({
  pageDbId,
  onSuccess,
  onError,
}: {
  pageDbId: PageObject['id'];
  onSuccess: () => void;
  onError: () => void;
}) => {
  const { currentCompany } = useCurrentCompany();
  const queryClient = useQueryClient();

  return useMutation<
    SaveAsPageTemplateResponse,
    V3ApiFailedResponse,
    SaveAsPageTemplateParams
  >({
    mutationFn: async (params) => {
      const { title, description } = params;

      return request({
        url: `pages/${pageDbId}/templates/from_page`,
        method: 'post',
        data: {
          title,
          description,
        },
      });
    },
    onSuccess: ({ data }) => {
      onSuccess?.();
      queryClient.invalidateQueries({
        queryKey: [PAGE_TEMPLATES_QUERY_KEY, currentCompany.id],
      });

      steven.entityCrud({
        action: 'created',
        entity_type: 'page_template',
        entity_id: `${data.id}`,
        source: 'page',
      });
    },
    onError: () => {
      onError?.();
    },
  });
};
